<button
  type="button"
  role="switch"
  class="account-switch"
  [attr.aria-checked]="checked"
  [attr.aria-label]="label"
  [disabled]="disabled"
  (click)="onClick()"
></button>
